import BlockStyleCommand from "./BlockStyleCommand";
import BlockStyleEditing from "./BlockStyleEditing";
import BlockStyleUI from "./BlockStyleUI";

import { Plugin } from "@ckeditor/ckeditor5-core";

import "./BlockStyle.css";

export default class BlockStyle extends Plugin {
  init() {
    const editor = this.editor;
  }

  static get pluginName() {
    return "BlockStyle";
  }

  static get requires() {
    return [BlockStyleCommand, BlockStyleEditing, BlockStyleUI];
  }
}
